<section class="wrap">
  <div class="overlay">
    <div class="logout-button">
      <app-logout-button></app-logout-button>
    </div>
    <div class="lang-selector">
      <lang-selector></lang-selector>
    </div>
  </div>
  <header class="hero">
    <div class="brand">
      <img [src]="getLogoPath()" alt="">
    </div>

    <div class="actions">
      <a *ngFor="let a of topActions" (click)="openAction(a)" class="action-link">
        <round-button [label]="a.label" class="action-btn"></round-button>
      </a>
    </div>
  </header>
  <main class="grid">
    <tile-card *ngFor="let tile of tiles" [tile]="tile" (click)="onTileClick(tile)"></tile-card>
  </main>
  <modal-check-in-legal-advice [show]="activeModal == 'checkin-legal-advice' && showModal"
                               (close)="closeCheckinLegalAdviceModal()"
                               *ngIf="activeModal == 'checkin-legal-advice' && showModal"></modal-check-in-legal-advice>
  <modal-check-in-hosts-count [show]="activeModal == 'checkin-pending-host' && showModal"
                              (close)="closeCheckinPendingHostModal()" title="Check-In"
                              [pendingHostsCounts]="pendingCheckIns(this.flow)" [showCloseButton]="false"
                              *ngIf="activeModal == 'checkin-pending-host' && showModal"></modal-check-in-hosts-count>
</section>
